{
  "api_clients.actions.create": "Create client",
  "api_clients.actions.permissions": "Assign permissions",
  "api_clients.actions.apps": "Authorize Apps",
  "api_clients.actions.rotate": "Create secret",
  "api_clients.actions.secrets": "Manage secrets",
  "api_clients.cidrs.any": "Any source",
  "api_clients.columns.actions": "Actions",
  "api_clients.columns.apps": "Authorized Apps",
  "api_clients.columns.cidrs": "Allowed CIDRs",
  "api_clients.columns.name": "Client",
  "api_clients.columns.secrets": "Active secrets",
  "api_clients.columns.status": "Status",
  "api_clients.description": "Manage tenant machine identities, network scopes, credentials, and stable permission codes.",
  "api_clients.detail.back": "Back to API Clients",
  "api_clients.detail.client_id": "Client ID",
  "api_clients.detail.created_at": "Created",
  "api_clients.detail.description": "Review this tenant machine identity without exposing plaintext credentials.",
  "api_clients.detail.expires_at": "Expires",
  "api_clients.detail.load_error": "API Client details could not be loaded.",
  "api_clients.detail.no_permissions": "No permission codes assigned",
  "api_clients.detail.no_secrets": "No secret metadata",
  "api_clients.detail.permissions": "Permission codes",
  "api_clients.detail.updated_at": "Updated",
  "api_clients.editor.cidrs": "Allowed CIDRs",
  "api_clients.editor.cidrs_help": "Separate values with commas or lines. Leave empty to allow any source IP.",
  "api_clients.editor.create": "Create API Client",
  "api_clients.editor.description": "Description",
  "api_clients.editor.edit": "Edit API Client",
  "api_clients.editor.expires": "Expires at",
  "api_clients.editor.name": "Name",
  "api_clients.editor.status": "Status",
  "api_clients.empty": "No API Clients match these filters",
  "api_clients.feedback.error": "The operation failed. Check the input and permissions, then retry.",
  "api_clients.feedback.revoked": "Client secret revoked",
  "api_clients.feedback.saved": "API Client saved",
  "api_clients.feedback.apps_saved": "Application access scope saved",
  "api_clients.apps.title": "Authorize accessible applications",
  "api_clients.apps.selector": "Application allowlist",
  "api_clients.apps.empty_denies": "An empty allowlist denies this client access to every application. Select each App explicitly.",
  "api_clients.filters.landmark": "API Client filters",
  "api_clients.filters.query": "Search name or client ID",
  "api_clients.filters.status": "Client status",
  "api_clients.permissions.selector": "Client permission codes",
  "api_clients.permissions.title": "Assign stable permission codes",
  "api_clients.safety.description": "Secrets are shown once and only hashes are stored. Issued tokens always use the ak-api audience and cannot call Admin APIs.",
  "api_clients.safety.title": "Machine and Admin tokens are isolated",
  "api_clients.secret.ack": "I have stored this secret securely",
  "api_clients.secret.close": "Saved and close",
  "api_clients.secret.title": "Save client secret",
  "api_clients.secret.value": "Client secret",
  "api_clients.secret.warning": "This secret is displayed once and cannot be recovered after closing. Copy it to secure storage now.",
  "api_clients.secrets.active": "Active",
  "api_clients.secrets.limit": "Keep at most two active secrets to support rotation without downtime.",
  "api_clients.secrets.revoke": "Revoke",
  "api_clients.secrets.revoke_confirm": "After revoking {prefix}, new requests using that secret will fail immediately.",
  "api_clients.secrets.revoke_title": "Revoke client secret",
  "api_clients.secrets.revoked": "Revoked",
  "api_clients.secrets.title": "Client secrets",
  "api_clients.status.active": "Active",
  "api_clients.status.disabled": "Disabled",
  "api_clients.title": "API Clients",
  "block_rules.action.challenge": "Require challenge",
  "block_rules.action.deny": "Deny",
  "block_rules.action.rate_limit": "Rate limit",
  "block_rules.actions.create": "Create rule",
  "block_rules.actions.revoke": "Revoke",
  "block_rules.columns.actions": "Actions",
  "block_rules.columns.expiry": "Expires",
  "block_rules.columns.scope": "Scope",
  "block_rules.columns.status": "Status",
  "block_rules.columns.subject": "Redacted subject",
  "block_rules.description": "Manage deny, challenge, and rate-limit rules for the active tenant. Subjects are always redacted by the server.",
  "block_rules.editor.action": "Action",
  "block_rules.editor.create": "Create access rule",
  "block_rules.editor.edit": "Edit access rule",
  "block_rules.editor.expires_at": "Expires",
  "block_rules.editor.reason": "Reason",
  "block_rules.editor.starts_at": "Starts",
  "block_rules.editor.status": "Status",
  "block_rules.editor.subject_help": "The raw value is accepted only at creation; later responses contain only a redacted hint.",
  "block_rules.editor.subject_redacted": "A saved subject cannot be returned or changed. Revoke and create a new rule to replace it.",
  "block_rules.editor.subject_type": "Subject type",
  "block_rules.editor.subject_value": "Subject value",
  "block_rules.empty": "No access rules",
  "block_rules.expiry.active": "Valid",
  "block_rules.expiry.expired": "Expired",
  "block_rules.expiry.never": "Never expires",
  "block_rules.feedback.error": "The access-rule operation failed. Check the input and permissions.",
  "block_rules.feedback.revoked": "Access rule revoked",
  "block_rules.feedback.saved": "Access rule saved",
  "block_rules.feedback.validation": "Check the subject format and time range, then confirm the impact",
  "block_rules.filters.expiry": "Expiry",
  "block_rules.filters.hint": "Search redacted subject",
  "block_rules.filters.landmark": "Access-rule filters",
  "block_rules.filters.status": "Status",
  "block_rules.filters.type": "Subject type",
  "block_rules.impact.ack": "I verified the subject, scope, action, and lifetime",
  "block_rules.impact.description": "Apply “{action}” to {subject}. Verify the scope and lifetime.",
  "block_rules.impact.pending": "pending subject",
  "block_rules.impact.title": "Impact confirmation",
  "block_rules.revoke.confirm": "Revoke the “{action}” rule for {subject} and retain an immutable audit record.",
  "block_rules.revoke.title": "Revoke this access rule?",
  "block_rules.safety.description": "Verify the subject, scope, action, and lifetime before creating or revoking. Raw subjects never appear in lists, audits, or screenshots.",
  "block_rules.safety.title": "Rules affect sign-in and access decisions",
  "block_rules.scope.tenant": "Active tenant",
  "block_rules.status.active": "Active",
  "block_rules.status.disabled": "Disabled",
  "block_rules.subject.cidr": "IP network",
  "block_rules.subject.device": "Device",
  "block_rules.subject.identifier": "Sign-in identifier",
  "block_rules.subject.ip": "IP address",
  "block_rules.subject.user": "User",
  "block_rules.title": "Access Rules",
  "ops.actions.copy": "Copy diagnostics",
  "ops.capabilities.access_rules": "Access rules",
  "ops.capabilities.api_clients": "API clients",
  "ops.capabilities.assignments": "Assignments",
  "ops.capabilities.authentication": "Authentication",
  "ops.capabilities.avatars": "Avatars",
  "ops.capabilities.configuration": "Configuration",
  "ops.capabilities.deliveries": "Deliveries",
  "ops.capabilities.dependency_status": "Dependency status",
  "ops.capabilities.dictionaries": "Dictionaries",
  "ops.capabilities.files": "Files",
  "ops.capabilities.health": "Service health",
  "ops.capabilities.login_logs": "Login logs",
  "ops.capabilities.menus": "Menus",
  "ops.capabilities.messages": "Messages",
  "ops.capabilities.mfa": "MFA",
  "ops.capabilities.multipart_upload": "Multipart upload",
  "ops.capabilities.notices": "Notices",
  "ops.capabilities.oauth": "OAuth",
  "ops.capabilities.operation_logs": "Operation logs",
  "ops.capabilities.positions": "Positions",
  "ops.capabilities.private_download": "Protected download",
  "ops.capabilities.queue_summary": "Queue summary",
  "ops.capabilities.regions": "Regions",
  "ops.capabilities.roles": "Roles",
  "ops.capabilities.runs": "Run history",
  "ops.capabilities.runtime_summary": "Runtime summary",
  "ops.capabilities.schedules": "Schedules",
  "ops.capabilities.security_events": "Security events",
  "ops.capabilities.sessions": "Sessions",
  "ops.capabilities.templates": "Templates",
  "ops.capabilities.tenants": "Tenants",
  "ops.capabilities.units": "Organization units",
  "ops.capabilities.users": "Users",
  "ops.capabilities.webhooks": "Webhooks",
  "ops.capabilities.worker": "Worker",
  "ops.columns.capabilities": "Capabilities",
  "ops.columns.checked": "Checked",
  "ops.columns.dependency": "Dependency",
  "ops.columns.latency": "Latency",
  "ops.columns.module": "Module",
  "ops.columns.status": "Status",
  "ops.columns.version": "Version",
  "ops.dependencies.table_label": "Dependency health details",
  "ops.dependencies.title": "Dependency health",
  "ops.dependency.api": "API",
  "ops.dependency.object_storage": "Object storage",
  "ops.dependency.postgresql": "PostgreSQL",
  "ops.dependency.redis": "Redis",
  "ops.description": "Review a safe diagnostic summary for the API, dependencies, Worker, queues, and runtime versions.",
  "ops.latency": "{value} ms",
  "ops.loading": "Loading",
  "ops.module_status.disabled": "Disabled",
  "ops.module_status.enabled": "Enabled",
  "ops.modules.audit.description": "Operation logs, login logs, and security events.",
  "ops.modules.audit.name": "Audit and security",
  "ops.modules.empty": "No compiled modules",
  "ops.modules.iam.description": "Authentication, users, tenants, roles, sessions, MFA, OAuth, and access rules.",
  "ops.modules.iam.name": "Identity and access",
  "ops.modules.jobs.description": "Schedules, execution history, and Worker processing.",
  "ops.modules.jobs.name": "Jobs",
  "ops.modules.notify.description": "Notices, messages, templates, and delivery tracking.",
  "ops.modules.notify.name": "Notifications",
  "ops.modules.ops.description": "Service health, runtime summaries, dependencies, and queue status.",
  "ops.modules.ops.name": "Operations monitoring",
  "ops.modules.org.description": "Organization units, positions, and user assignments.",
  "ops.modules.org.name": "Organization",
  "ops.modules.storage.description": "Avatars, files, multipart uploads, and protected downloads.",
  "ops.modules.storage.name": "Storage",
  "ops.modules.sys.description": "Configuration, dictionaries, regions, menus, API clients, and webhooks.",
  "ops.modules.sys.name": "System configuration",
  "ops.modules.table_label": "Compiled domain module details",
  "ops.modules.title": "Compiled domain modules",
  "ops.runtime.app_version": "Application version",
  "ops.runtime.failed_runs": "Failed jobs in 24 hours",
  "ops.runtime.go_version": "Go version",
  "ops.runtime.heartbeat": "Latest Worker heartbeat",
  "ops.runtime.success_runs": "Successful jobs in 24 hours",
  "ops.runtime.title": "Runtime summary",
  "ops.runtime.uptime": "Uptime",
  "ops.safety.description": "Connection strings, keys, environment variables, local paths, and raw exceptions are not shown. Not configured and unknown are never presented as passed.",
  "ops.safety.title": "Diagnostics are constrained",
  "ops.status.degraded": "Degraded",
  "ops.status.not_configured": "Not configured",
  "ops.status.ready": "Ready",
  "ops.status.unavailable": "Unavailable",
  "ops.status.unknown": "Unknown",
  "ops.summary.overall": "Overall status",
  "ops.summary.pending": "Pending queue",
  "ops.summary.worker": "Worker status",
  "ops.title": "Service Status",
  "ops.uptime": "{value} seconds",
  "schedules.actions.create": "Create job",
  "schedules.actions.execute": "Run now",
  "schedules.actions.pause": "Pause",
  "schedules.actions.resume": "Resume",
  "schedules.actions.runs": "Run history",
  "schedules.columns.actions": "Actions",
  "schedules.columns.cron": "Cron and time zone",
  "schedules.columns.handler": "Handler",
  "schedules.columns.name": "Job",
  "schedules.columns.next_run": "Next run",
  "schedules.columns.status": "Status",
  "schedules.cron.custom": "Cron: {expression}",
  "schedules.cron.daily": "Runs daily at midnight",
  "schedules.cron.every_minute": "Runs every minute",
  "schedules.cron.hourly": "Runs at the start of every hour",
  "schedules.description": "Manage compiled background handlers, Cron time-zone policies, and safe run history.",
  "schedules.editor.code": "Job code",
  "schedules.editor.create_title": "Create scheduled job",
  "schedules.editor.cron": "Cron expression",
  "schedules.editor.edit_title": "Edit scheduled job",
  "schedules.editor.handler": "Registered handler",
  "schedules.editor.handler_help": "Only safe handlers compiled into the server can be selected.",
  "schedules.editor.max_attempts": "Maximum attempts",
  "schedules.editor.misfire": "Misfire policy",
  "schedules.editor.name": "Job name",
  "schedules.editor.overlap": "Overlap policy",
  "schedules.editor.payload": "Job parameters JSON",
  "schedules.editor.payload_help": "Only object fields declared by the selected handler are accepted. Never include credentials.",
  "schedules.editor.time_zone": "IANA time zone",
  "schedules.editor.time_zone_help": "Examples: Asia/Shanghai and America/New_York.",
  "schedules.editor.timeout": "Timeout in seconds",
  "schedules.empty": "No scheduled jobs match these filters",
  "schedules.execute.confirm": "Queue “{name}” with registered handler {handler}? An idempotency key protects duplicate submissions.",
  "schedules.execute.title": "Run this job now?",
  "schedules.feedback.action_error": "The action failed. The job state may have changed; refresh and try again.",
  "schedules.feedback.executed": "The job was safely queued for execution.",
  "schedules.feedback.load_error": "Scheduled jobs could not be loaded.",
  "schedules.feedback.paused": "Scheduled job paused.",
  "schedules.feedback.preview_error": "The Cron expression or time zone could not be parsed.",
  "schedules.feedback.resumed": "Scheduled job resumed.",
  "schedules.feedback.runs_error": "Run history could not be loaded.",
  "schedules.feedback.save_error": "The scheduled job could not be saved. Check the input and try again.",
  "schedules.feedback.saved": "Scheduled job saved.",
  "schedules.filters.landmark": "Scheduled job filters",
  "schedules.filters.query": "Search name or code",
  "schedules.filters.status": "Job status",
  "schedules.filters.time_zone": "Time zone",
  "schedules.handlers.system_health_snapshot.description": "Checks PostgreSQL availability and records a stable result code.",
  "schedules.handlers.system_health_snapshot.name": "System health snapshot",
  "schedules.misfire.catch_up": "Bounded catch-up",
  "schedules.misfire.fire_once": "Run once after recovery",
  "schedules.misfire.ignore": "Ignore missed runs",
  "schedules.overlap.allow": "Allow concurrent runs",
  "schedules.overlap.replace": "Cancel and replace the old run",
  "schedules.overlap.skip": "Skip overlapping runs",
  "schedules.preview.action": "Recalculate",
  "schedules.preview.empty": "Enter a valid Cron expression and time zone to see the server-calculated schedule.",
  "schedules.preview.item": "Run {count}",
  "schedules.preview.title": "Next 5 runs",
  "schedules.run_status.cancelled": "Cancelled",
  "schedules.run_status.failed": "Failed",
  "schedules.run_status.queued": "Queued",
  "schedules.run_status.running": "Running",
  "schedules.run_status.skipped": "Skipped",
  "schedules.run_status.succeeded": "Succeeded",
  "schedules.runs.back": "Back to scheduled jobs",
  "schedules.runs.columns.attempt": "Attempt",
  "schedules.runs.columns.result": "Safe result",
  "schedules.runs.columns.scheduled": "Scheduled for",
  "schedules.runs.columns.status": "Status",
  "schedules.runs.columns.trigger": "Trigger",
  "schedules.runs.description": "Inspect tenant-scoped runs for schedule {id}. Results contain only bounded server-safe summaries.",
  "schedules.runs.empty": "No runs match these filters",
  "schedules.runs.filters.status": "Run status",
  "schedules.runs.load_error": "Execution history could not be loaded.",
  "schedules.runs.page_title": "Execution history",
  "schedules.runs.schedule_id": "Schedule ID",
  "schedules.runs.table_landmark": "Job run history table",
  "schedules.runs.title": "Run history for “{name}”",
  "schedules.safety.description": "Jobs cannot run Shell, SQL, or uploaded code. IANA time zones are evaluated by the server across daylight-saving boundaries.",
  "schedules.safety.title": "Registered handlers only",
  "schedules.status.active": "Active",
  "schedules.status.disabled": "Disabled",
  "schedules.status.paused": "Paused",
  "schedules.status_change.pause_confirm": "Pausing “{name}” stops new scheduled runs. Runs already queued are not affected.",
  "schedules.status_change.pause_title": "Pause scheduled job?",
  "schedules.status_change.resume_confirm": "Resuming “{name}” continues scheduling with its Cron expression and time zone.",
  "schedules.status_change.resume_title": "Resume scheduled job?",
  "schedules.table.landmark": "Scheduled jobs table",
  "schedules.title": "Scheduled jobs",
  "schedules.trigger.manual": "Manual",
  "schedules.trigger.retry": "Retry",
  "schedules.trigger.schedule": "Schedule",
  "schedules.validation.invalid": "Check this field.",
  "system.access.load_error": "Could not load access control data",
  "system.access.menus.actions.create": "Create menu",
  "system.access.menus.actions.label": "Actions",
  "system.access.menus.actions.move": "Move",
  "system.access.menus.component_notice": "Page components can only be selected from the compiled static route registry. Menus never grant API permissions.",
  "system.access.menus.core": "Core",
  "system.access.menus.delete.impact": "Menus with children or role assignments cannot be deleted. Current role assignments: {count}.",
  "system.access.menus.delete.title": "Delete this menu?",
  "system.access.menus.description": "Manage the current tenant menu tree. Core menus are visible but immutable.",
  "system.access.menus.editor.create_title": "Create menu",
  "system.access.menus.editor.edit_title": "Edit menu",
  "system.access.menus.editor.title": "Menu editor",
  "system.access.menus.empty": "No menus match the filters",
  "system.access.menus.feedback.created": "Menu created",
  "system.access.menus.feedback.deleted": "Menu deleted",
  "system.access.menus.feedback.moved": "Menu moved",
  "system.access.menus.feedback.saved": "Menu saved",
  "system.access.menus.fields.affix": "Affix",
  "system.access.menus.fields.code": "Menu code",
  "system.access.menus.fields.component": "Static component",
  "system.access.menus.fields.external_url": "External URL",
  "system.access.menus.fields.hidden": "Hidden",
  "system.access.menus.fields.i18n_key": "Translation key",
  "system.access.menus.fields.icon": "Icon key",
  "system.access.menus.fields.parent": "Parent menu",
  "system.access.menus.fields.path": "Route path",
  "system.access.menus.fields.permission": "View permission",
  "system.access.menus.fields.sort_order": "Sort order",
  "system.access.menus.fields.status": "Status",
  "system.access.menus.fields.title": "Title",
  "system.access.menus.fields.type": "Menu type",
  "system.access.menus.filters.query": "Search title or code",
  "system.access.menus.filters.status": "Filter by status",
  "system.access.menus.filters.type": "Filter by type",
  "system.access.menus.move.description": "Choose a parent and sort order. The backend rejects cycles and trees deeper than three levels.",
  "system.access.menus.move.title": "Move menu",
  "system.access.menus.root": "Root level",
  "system.access.menus.type.directory": "Directory",
  "system.access.menus.type.external": "External link",
  "system.access.menus.type.page": "Page",
  "system.access.permissions.copied": "Copied {code}",
  "system.access.permissions.copy": "Copy code",
  "system.access.permissions.description": "Read-only catalog of stable permission codes defined by backend code and seeds.",
  "system.access.permissions.empty": "No permissions match the filters",
  "system.access.permissions.fields.action": "Action",
  "system.access.permissions.fields.code": "Permission code",
  "system.access.permissions.fields.kind": "Kind",
  "system.access.permissions.fields.name": "Name",
  "system.access.permissions.fields.resource": "Module / resource",
  "system.access.permissions.fields.status": "Status",
  "system.access.permissions.filters.kind": "Filter by kind",
  "system.access.permissions.filters.module": "Filter by module",
  "system.access.permissions.filters.query": "Search permission code or name",
  "system.access.permissions.filters.status": "Filter by status",
  "system.access.permissions.kind.api": "API",
  "system.access.permissions.kind.feature": "Feature",
  "system.access.permissions.kind.ui_action": "UI action",
  "system.access.permissions.read_only": "Read only",
  "system.access.roles.actions.create": "Create role",
  "system.access.roles.actions.label": "Actions",
  "system.access.roles.delete.impact": "The role can only be deleted when it has no members. Current member count: {count}.",
  "system.access.roles.delete.title": "Delete this role?",
  "system.access.roles.description": "Manage tenant roles while keeping API permissions, navigation menus, and data scope separate.",
  "system.access.roles.detail.back": "Back to roles",
  "system.access.roles.detail.basic": "Basic",
  "system.access.roles.detail.data_scope": "Data scope",
  "system.access.roles.detail.members": "Members",
  "system.access.roles.detail.menus": "Menus",
  "system.access.roles.detail.permissions": "Permissions",
  "system.access.roles.editor.create_title": "Create custom role",
  "system.access.roles.empty": "No roles match the filters",
  "system.access.roles.feedback.created": "Role {name} created",
  "system.access.roles.feedback.deleted": "Role {name} deleted",
  "system.access.roles.feedback.menus_saved": "Role menus saved",
  "system.access.roles.feedback.permissions_saved": "Role permissions saved",
  "system.access.roles.feedback.saved": "Role settings saved",
  "system.access.roles.feedback.scope_saved": "Role data scope saved",
  "system.access.roles.fields.code": "Role code",
  "system.access.roles.fields.description": "Description",
  "system.access.roles.fields.members": "Members",
  "system.access.roles.fields.name": "Role name",
  "system.access.roles.fields.scope": "Data scope",
  "system.access.roles.fields.scope_units": "Custom organization units",
  "system.access.roles.fields.sort_order": "Sort order",
  "system.access.roles.fields.status": "Status",
  "system.access.roles.fields.type": "Role type",
  "system.access.roles.filters.query": "Search role name or code",
  "system.access.roles.filters.status": "Filter by status",
  "system.access.roles.filters.type": "Filter by role type",
  "system.access.roles.members.description": "Open the user list with this role filter to manage role members.",
  "system.access.roles.members.open": "Open filtered users",
  "system.access.roles.menu_separation": "Menus control navigation only. API authorization is always defined by the separate permission selection.",
  "system.access.roles.scope.all": "All data",
  "system.access.roles.scope.custom": "Custom units",
  "system.access.roles.scope.department": "Department",
  "system.access.roles.scope.department_tree": "Department and descendants",
  "system.access.roles.scope.self": "Self only",
  "system.access.roles.scope.tenant": "Current tenant",
  "system.access.roles.system_immutable": "This system role is maintained by the platform seed and cannot be changed or deleted here.",
  "system.access.roles.type.custom": "Custom",
  "system.access.roles.type.system": "System",
  "system.access.selected": "{count} selected",
  "system.access.status.active": "Active",
  "system.access.status.disabled": "Disabled",
  "system.audit.actions.copy_request_id": "Copy request ID",
  "system.audit.actions.resolve": "Resolve event",
  "system.audit.actions.view": "View details",
  "system.audit.event_detail.back": "Back to security events",
  "system.audit.event_detail.details": "Redacted details",
  "system.audit.event_detail.metadata": "Event metadata",
  "system.audit.event_detail.redaction_notice": "Credential, token, secret, authorization, cookie, OTP, MFA, and API key fields are redacted by the server.",
  "system.audit.events.description": "Investigate tenant security events and record an immutable resolution action.",
  "system.audit.events.empty": "No security events match these filters.",
  "system.audit.feedback.request_id_copied": "Request ID copied.",
  "system.audit.fields.action": "Action",
  "system.audit.fields.actions": "Actions",
  "system.audit.fields.audience": "Audience",
  "system.audit.fields.auth_method": "Authentication method",
  "system.audit.fields.event_type": "Event type",
  "system.audit.fields.failure_reason": "Failure reason",
  "system.audit.fields.identifier_hint": "Identifier hint",
  "system.audit.fields.ip": "Client IP",
  "system.audit.fields.module": "Module",
  "system.audit.fields.request_id": "Request ID",
  "system.audit.fields.resolved_by": "Resolved by",
  "system.audit.fields.resource": "Resource",
  "system.audit.fields.result": "Result",
  "system.audit.fields.session_id": "Session ID",
  "system.audit.fields.severity": "Severity",
  "system.audit.fields.source": "Source",
  "system.audit.fields.status": "Status",
  "system.audit.fields.time": "Time",
  "system.audit.fields.user_id": "User ID",
  "system.audit.filters.audience": "Audience",
  "system.audit.filters.auth_method": "Authentication method",
  "system.audit.filters.from": "From date",
  "system.audit.filters.module": "Module",
  "system.audit.filters.query": "Search request, action, event, or safe identifier hint",
  "system.audit.filters.result": "Result",
  "system.audit.filters.severity": "Severity",
  "system.audit.filters.source": "Source",
  "system.audit.filters.status": "Status",
  "system.audit.filters.to": "To date",
  "system.audit.load_error": "Audit data could not be loaded.",
  "system.audit.logins.description": "Review authentication outcomes without exposing account identifiers or credential material.",
  "system.audit.logins.empty": "No login logs match these filters.",
  "system.audit.operation_detail.after": "After",
  "system.audit.operation_detail.before": "Before",
  "system.audit.operation_detail.empty_json": "No recorded fields",
  "system.audit.operation_detail.redaction_notice": "Sensitive fields are recursively redacted by the server before this data reaches the browser.",
  "system.audit.operation_detail.request_summary": "Request summary",
  "system.audit.operation_detail.title": "Operation details",
  "system.audit.operations.description": "Review tenant-scoped administrative actions and field-redacted changes.",
  "system.audit.operations.empty": "No operation logs match these filters.",
  "system.audit.resolve.already": "This security event has already been resolved.",
  "system.audit.resolve.impact": "This records your user, session, request, and resolution time in an immutable operation audit. The event cannot be resolved twice.",
  "system.audit.resolve.success": "Security event resolved and audited.",
  "system.audit.resolve.title": "Resolve this security event?",
  "system.audit.values.blocked": "Blocked",
  "system.audit.values.critical": "Critical",
  "system.audit.values.failure": "Failure",
  "system.audit.values.high": "High",
  "system.audit.values.info": "Info",
  "system.audit.values.low": "Low",
  "system.audit.values.medium": "Medium",
  "system.audit.values.open": "Open",
  "system.audit.values.resolved": "Resolved",
  "system.audit.values.success": "Success",
  "system.audit.values.unknown": "Not available",
  "system.files.actions.cancel_upload": "Cancel upload",
  "system.files.actions.choose": "Choose file",
  "system.files.actions.details": "View details",
  "system.files.actions.download": "Download",
  "system.files.actions.pause": "Pause",
  "system.files.actions.resume": "Resume",
  "system.files.actions.select": "Select",
  "system.files.actions.upload": "Upload file",
  "system.files.columns.actions": "Actions",
  "system.files.columns.created": "Created",
  "system.files.columns.file": "File",
  "system.files.columns.provider": "Provider",
  "system.files.columns.scan": "Scan",
  "system.files.columns.size": "Size",
  "system.files.columns.status": "Status",
  "system.files.columns.uploaded": "Uploaded",
  "system.files.columns.usages": "Usages",
  "system.files.delete.impact": "The file object will be removed and cannot be recovered.",
  "system.files.delete.in_use": "This file is referenced {count} time(s) and cannot be deleted.",
  "system.files.delete.title": "Delete file?",
  "system.files.description": "Upload, inspect and safely manage tenant files.",
  "system.files.detail.no_usages": "This file has no active usages.",
  "system.files.detail.scan_gate": "Only ready files with a clean or explicitly skipped scan can be selected or downloaded.",
  "system.files.detail.title": "File details",
  "system.files.detail.usages": "Business usages",
  "system.files.empty": "No matching files",
  "system.files.feedback.deleted": "File deleted.",
  "system.files.feedback.downloaded": "Download started.",
  "system.files.filters.media": "Media type prefix",
  "system.files.filters.provider": "Storage provider",
  "system.files.filters.query": "Search file name",
  "system.files.filters.scan": "Scan status",
  "system.files.filters.status": "File status",
  "system.files.filters.uploaded_from": "Start date",
  "system.files.filters.uploaded_range": "Upload date range",
  "system.files.filters.uploaded_to": "End date",
  "system.files.load_error": "Files could not be loaded.",
  "system.files.picker.description": "Only ready and scan-safe files can be selected.",
  "system.files.picker.preview.close": "Close file preview",
  "system.files.picker.preview.empty": "Select a file to preview it here",
  "system.files.picker.preview.error": "The file preview could not be loaded",
  "system.files.picker.preview.open": "Show file preview",
  "system.files.picker.preview.title": "File preview",
  "system.files.picker.preview.unsupported": "Preview is not available for this file type",
  "system.files.picker.selected": "Selected: {name}",
  "system.files.picker.title": "Choose a file",
  "system.files.picker.type.all": "All files",
  "system.files.picker.type.image": "Images",
  "system.files.picker.type.label": "File type",
  "system.files.picker.type.other": "Other files",
  "system.files.picker.type.video": "Videos",
  "system.files.picker.view.grid": "Grid view",
  "system.files.picker.view.label": "Change file view",
  "system.files.picker.view.table": "Table view",
  "system.files.picker.view.thumbnail": "Thumbnail view",
  "system.files.picker.window.drag": "Drag the file picker dialog; use Alt plus an arrow key to move it",
  "system.files.picker.window.maximize": "Maximize dialog",
  "system.files.picker.window.resize": "Resize dialog; use arrow keys and hold Shift for larger steps",
  "system.files.picker.window.restore": "Restore dialog",
  "system.files.picker.window.split": "Drag to resize the file list and preview",
  "system.files.provider.local": "Local storage",
  "system.files.provider.minio": "MinIO",
  "system.files.provider.s3": "S3-compatible storage",
  "system.files.scan.clean": "Clean",
  "system.files.scan.failed": "Scan failed",
  "system.files.scan.infected": "Infected",
  "system.files.scan.pending": "Scan pending",
  "system.files.scan.skipped": "Scan skipped",
  "system.files.status.pending": "Pending",
  "system.files.status.quarantined": "Quarantined",
  "system.files.status.ready": "Ready",
  "system.files.title": "File storage",
  "system.files.upload.cancelled": "Upload session cancelled and uploaded parts discarded.",
  "system.files.upload.completed": "File uploaded and verified.",
  "system.files.upload.description": "Files are uploaded in resumable 5 MiB parts and verified before becoming available.",
  "system.files.upload.error": "Upload failed. Resume to retry missing parts.",
  "system.files.upload.invalid": "Choose a non-empty file no larger than 100 MiB.",
  "system.files.upload.invalid_policy": "The file size or type is not allowed by the active tenant upload policy.",
  "system.files.upload.paused": "Upload paused. Resume keeps the completed parts.",
  "system.files.upload.policy": "{provider} · up to {size}",
  "system.files.upload.policy_error": "The upload policy is unavailable. Complete cloud storage configuration first.",
  "system.files.upload.progress": "Upload progress: {percent}%",
  "system.files.upload.title": "Multipart upload",
  "system.org.feedback.deleted": "Deleted successfully",
  "system.org.feedback.moved": "Moved successfully",
  "system.org.feedback.saved": "Saved successfully",
  "system.org.filters.query": "Search by name or code",
  "system.org.filters.status": "Status",
  "system.org.load_error": "Organization data could not be loaded.",
  "system.org.positions.actions.create": "Create position",
  "system.org.positions.actions.label": "Actions",
  "system.org.positions.delete.impact": "Assigned members: {members}. The server rejects deletion while members are assigned.",
  "system.org.positions.delete.title": "Delete position?",
  "system.org.positions.description": "Maintain the tenant position catalog and review live member occupancy.",
  "system.org.positions.editor.create_title": "Create position",
  "system.org.positions.editor.edit_title": "Edit position",
  "system.org.positions.empty": "No positions",
  "system.org.positions.fields.code": "Position code",
  "system.org.positions.fields.description": "Description",
  "system.org.positions.fields.member_count": "Members",
  "system.org.positions.fields.name": "Position name",
  "system.org.positions.fields.sort_order": "Sort order",
  "system.org.positions.fields.status": "Status",
  "system.org.positions.filters.department": "Filter by department",
  "system.org.unit_types.company": "Company",
  "system.org.unit_types.department": "Department",
  "system.org.unit_types.division": "Division",
  "system.org.unit_types.group": "Group",
  "system.org.unit_types.team": "Team",
  "system.org.units.actions.create": "Create department",
  "system.org.units.actions.move": "Move",
  "system.org.units.delete.impact": "Direct children: {children}; direct members: {members}. The server rejects deletion while occupied.",
  "system.org.units.delete.title": "Delete department?",
  "system.org.units.description": "Maintain the tenant organization tree with a fully keyboard-accessible move form.",
  "system.org.units.editor.create_title": "Create department",
  "system.org.units.editor.edit_title": "Edit department",
  "system.org.units.empty": "No departments",
  "system.org.units.fields.child_count": "Direct children",
  "system.org.units.fields.code": "Department code",
  "system.org.units.fields.contact": "Contact",
  "system.org.units.fields.direct_member_count": "Direct members",
  "system.org.units.fields.email": "Email",
  "system.org.units.fields.name": "Department name",
  "system.org.units.fields.parent_id": "Parent department",
  "system.org.units.fields.phone": "Phone",
  "system.org.units.fields.sort_order": "Sort order",
  "system.org.units.fields.status": "Status",
  "system.org.units.fields.unit_type": "Organization type",
  "system.org.units.move.description": "Choose a new parent and sort order. A unit cannot move beneath itself or a descendant.",
  "system.org.units.move.root": "Top-level organization",
  "system.org.units.move.title": "Move department",
  "system.org.units.tree_label": "Organization tree",
  "system.sessions.actions.revoke": "Force offline",
  "system.sessions.current_warning": "This browser's current session is marked below. Forcing it offline will sign you out immediately.",
  "system.sessions.description": "Review tenant sessions using server-masked identity, device, and IP hints, then force compromised sessions offline.",
  "system.sessions.empty": "No sessions match these filters.",
  "system.sessions.fields.actions": "Actions",
  "system.sessions.fields.application": "Application / platform",
  "system.sessions.fields.device": "Device hint",
  "system.sessions.fields.expires": "Expires",
  "system.sessions.fields.ip": "IP hint",
  "system.sessions.fields.last_seen": "Last active",
  "system.sessions.fields.status": "Status",
  "system.sessions.fields.user": "User",
  "system.sessions.filters.audience": "Application",
  "system.sessions.filters.from": "Active from",
  "system.sessions.filters.ip": "Match IP",
  "system.sessions.filters.platform": "Platform",
  "system.sessions.filters.search": "Search user name or account",
  "system.sessions.filters.status": "Status",
  "system.sessions.filters.to": "Active to",
  "system.sessions.revoke.current_impact": "This is your current session. You will be signed out as soon as the action succeeds.",
  "system.sessions.revoke.impact": "{user} on {device} will lose access immediately. Its refresh-token family will also be revoked and the action will be audited.",
  "system.sessions.revoke.success": "Session forced offline and audit recorded.",
  "system.sessions.revoke.title": "Force this session offline?",
  "system.sessions.values.active": "Active",
  "system.sessions.values.ak-admin": "Admin",
  "system.sessions.values.ak-api": "API",
  "system.sessions.values.ak-mobile": "Mobile",
  "system.sessions.values.android": "Android",
  "system.sessions.values.current": "Current session",
  "system.sessions.values.desktop": "Desktop",
  "system.sessions.values.expired": "Expired",
  "system.sessions.values.harmonyos": "HarmonyOS",
  "system.sessions.values.ios": "iOS",
  "system.sessions.values.revoked": "Revoked",
  "system.sessions.values.unknown": "Unknown",
  "system.sessions.values.web": "Web",
  "system.tenants.actions.create": "Create tenant",
  "system.tenants.description": "Manage the current tenant, its members, and available workspaces. The server enforces tenant isolation.",
  "system.tenants.detail.back": "Back to tenants",
  "system.tenants.detail.members": "Members",
  "system.tenants.detail.overview": "Overview",
  "system.tenants.editor.create_title": "Create tenant",
  "system.tenants.empty": "No visible tenants",
  "system.tenants.feedback.created": "Tenant {name} was created and is available from the workspace switcher",
  "system.tenants.feedback.member_added": "Member added",
  "system.tenants.feedback.member_updated": "Member status updated",
  "system.tenants.feedback.saved": "Tenant saved",
  "system.tenants.fields.code": "Tenant code",
  "system.tenants.fields.created_at": "Created",
  "system.tenants.fields.members": "Members",
  "system.tenants.fields.name": "Tenant name",
  "system.tenants.fields.plan": "Plan",
  "system.tenants.fields.status": "Status",
  "system.tenants.filters.query": "Search name or code",
  "system.tenants.filters.status": "Filter by status",
  "system.tenants.load_error": "Could not load tenant data",
  "system.tenants.member_status.active": "Active",
  "system.tenants.member_status.left": "Left",
  "system.tenants.member_status.suspended": "Suspended",
  "system.tenants.members.actions": "Actions",
  "system.tenants.members.activate": "Activate",
  "system.tenants.members.add": "Add member",
  "system.tenants.members.add_title": "Add an existing user",
  "system.tenants.members.confirm_active": "Activate this member?",
  "system.tenants.members.confirm_impact": "This changes {name}'s tenant membership. Suspending or removing the member revokes their current tenant sessions.",
  "system.tenants.members.confirm_left": "Remove this member?",
  "system.tenants.members.confirm_suspended": "Suspend this member?",
  "system.tenants.members.display_name": "Tenant display name (optional)",
  "system.tenants.members.email": "User email",
  "system.tenants.members.empty": "No members",
  "system.tenants.members.joined_at": "Joined",
  "system.tenants.members.member": "Member",
  "system.tenants.members.remove": "Remove",
  "system.tenants.members.roles": "Roles",
  "system.tenants.members.status": "Status",
  "system.tenants.members.suspend": "Suspend",
  "system.tenants.status.active": "Active",
  "system.tenants.status.disabled": "Disabled",
  "system.users.actions.create": "Create user",
  "system.users.actions.disable": "Disable",
  "system.users.actions.enable": "Enable",
  "system.users.actions.export": "Export CSV",
  "system.users.actions.import": "Import CSV",
  "system.users.actions.label": "Actions",
  "system.users.actions.more": "More",
  "system.users.actions.reset_password": "Reset password",
  "system.users.bulk.disable_impact": "This will disable {count} tenant members and revoke their sessions in this tenant.",
  "system.users.bulk.disable_title": "Disable {count} users?",
  "system.users.bulk.enable_impact": "This will enable {count} tenant members.",
  "system.users.bulk.enable_title": "Enable {count} users?",
  "system.users.bulk.select_user": "Select {name}",
  "system.users.bulk.selected": "{count} selected",
  "system.users.description": "Manage tenant users, roles, organization assignments, and login sessions.",
  "system.users.detail.access": "Roles and organization",
  "system.users.detail.assignments": "Departments and positions",
  "system.users.detail.back": "Back to users",
  "system.users.detail.overview": "Overview",
  "system.users.detail.roles": "Roles",
  "system.users.detail.sessions": "Login sessions",
  "system.users.disable.impact": "Disable {name} and revoke {sessions} active sessions in this tenant.",
  "system.users.disable.title": "Disable user?",
  "system.users.editor.create_title": "Create user",
  "system.users.editor.edit_title": "Edit user",
  "system.users.empty": "No users",
  "system.users.enable.impact": "Restore this user's access to the current tenant.",
  "system.users.enable.title": "Enable user?",
  "system.users.feedback.assignments_saved": "Organization assignments saved",
  "system.users.feedback.bulk": "Updated {count} users",
  "system.users.feedback.created": "User created and required to change the password at first sign-in",
  "system.users.feedback.exported": "The user export download has started",
  "system.users.feedback.imported": "Import complete: {created} created, {failed} failed",
  "system.users.feedback.password_reset": "Password reset and {count} sessions revoked",
  "system.users.feedback.roles_saved": "Roles saved",
  "system.users.feedback.saved": "User profile saved",
  "system.users.feedback.session_revoked": "Session revoked",
  "system.users.feedback.status": "User status updated",
  "system.users.fields.created_at": "Created",
  "system.users.fields.department": "Department",
  "system.users.fields.display_name": "Display name",
  "system.users.fields.email": "Email",
  "system.users.fields.last_login": "Last sign-in",
  "system.users.fields.locale": "Language",
  "system.users.fields.positions": "Positions",
  "system.users.fields.roles": "Roles",
  "system.users.fields.status": "Status",
  "system.users.fields.temporary_password": "Temporary password",
  "system.users.fields.time_zone": "Time zone",
  "system.users.fields.user": "User",
  "system.users.filters.all_departments": "All departments",
  "system.users.filters.department": "Department filter",
  "system.users.filters.query": "Search name, email, or username",
  "system.users.filters.sort": "Sort",
  "system.users.filters.status": "Status filter",
  "system.users.load_error": "Unable to load user data.",
  "system.users.reset.impact": "Set a temporary password for {name}; all {sessions} active sessions will be revoked and a password change will be required at next sign-in.",
  "system.users.reset.title": "Reset user password?",
  "system.users.sessions.empty": "No login sessions",
  "system.users.sessions.ip": "IP address",
  "system.users.sessions.last_seen": "Last activity",
  "system.users.sessions.revoke": "Revoke session",
  "system.users.sessions.status.active": "Active",
  "system.users.sessions.status.expired": "Expired",
  "system.users.sessions.status.revoked": "Revoked",
  "system.users.sessions.user_agent": "Client",
  "system.users.sort.created_asc": "Oldest created",
  "system.users.sort.created_desc": "Newest created",
  "system.users.sort.last_login_desc": "Most recent sign-in",
  "system.users.sort.name_asc": "Name A–Z",
  "system.users.status.active": "Active",
  "system.users.status.disabled": "Disabled",
  "system.users.status.locked": "Locked",
  "system.users.status.pending": "Pending",
  "webhooks.actions.create": "Create endpoint",
  "webhooks.actions.deliveries": "View deliveries",
  "webhooks.actions.test": "Send test",
  "webhooks.columns.actions": "Actions",
  "webhooks.columns.delivery": "Delivery policy",
  "webhooks.columns.delivery_value": "Up to {attempts} attempts / {seconds}s timeout",
  "webhooks.columns.events": "Events",
  "webhooks.columns.name": "Endpoint",
  "webhooks.columns.status": "Status",
  "webhooks.deliveries.columns.attempts": "Attempts",
  "webhooks.deliveries.columns.created": "Created",
  "webhooks.deliveries.columns.event": "Event",
  "webhooks.deliveries.columns.status": "Status",
  "webhooks.deliveries.detail": "Delivery details",
  "webhooks.deliveries.empty": "No deliveries yet",
  "webhooks.deliveries.fields.event_id": "Event ID",
  "webhooks.deliveries.fields.payload": "Event payload",
  "webhooks.deliveries.fields.response_status": "HTTP status",
  "webhooks.deliveries.fields.status": "Status",
  "webhooks.deliveries.fields.summary": "Response or error summary",
  "webhooks.deliveries.not_found": "The webhook endpoint does not exist or is not accessible",
  "webhooks.deliveries.title": "Delivery history for “{name}”",
  "webhooks.delivery_status.cancelled": "Cancelled",
  "webhooks.delivery_status.failed": "Failed",
  "webhooks.delivery_status.pending": "Pending",
  "webhooks.delivery_status.processing": "Processing",
  "webhooks.delivery_status.succeeded": "Succeeded",
  "webhooks.description": "Configure signed HTTPS delivery for tenant events and inspect bounded response summaries.",
  "webhooks.editor.create": "Create webhook endpoint",
  "webhooks.editor.edit": "Edit webhook endpoint",
  "webhooks.editor.events": "Event codes",
  "webhooks.editor.events_help": "Separate values with commas or lines, for example order.created.",
  "webhooks.editor.max_attempts": "Maximum attempts",
  "webhooks.editor.name": "Name",
  "webhooks.editor.status": "Status",
  "webhooks.editor.timeout": "Timeout in seconds",
  "webhooks.editor.url": "HTTPS endpoint URL",
  "webhooks.editor.url_help": "Use a publicly routable HTTPS host. The development mock accepts hooks.example.test.",
  "webhooks.empty": "No webhook endpoints match these filters",
  "webhooks.feedback.error": "The webhook operation failed. Check the input and permissions.",
  "webhooks.feedback.saved": "Webhook endpoint saved",
  "webhooks.feedback.test_failed": "Test delivery failed. Review its safe summary in delivery history.",
  "webhooks.feedback.test_succeeded": "Test delivery succeeded",
  "webhooks.feedback.validation": "Check the URL, event codes, and delivery limits",
  "webhooks.filters.event_type": "Filter by event code",
  "webhooks.filters.landmark": "Webhook filters",
  "webhooks.filters.query": "Search name or URL",
  "webhooks.filters.status": "Endpoint status",
  "webhooks.safety.description": "Loopback, private, link-local, multicast addresses and redirects are blocked. DNS is resolved again before delivery, and every payload is signed with a timestamp, event ID, and HMAC-SHA256.",
  "webhooks.safety.title": "HTTPS and server-side SSRF protection are enforced",
  "webhooks.secret.ack": "I have stored the signing secret securely",
  "webhooks.secret.close": "Saved and close",
  "webhooks.secret.title": "Save webhook signing secret",
  "webhooks.secret.value": "Webhook signing secret",
  "webhooks.secret.warning": "The signing secret is displayed once; the server stores only AES-GCM ciphertext. Save it in the receiver's secure configuration now.",
  "webhooks.status.active": "Active",
  "webhooks.status.disabled": "Disabled",
  "webhooks.test.confirm": "Send event {event} to “{name}”. The same idempotency key will not be delivered twice.",
  "webhooks.test.title": "Send signed test event",
  "webhooks.title": "Webhooks",
  "ops.modules.ai.name": "AI Foundation",
  "ops.modules.ai.description": "Providers, models, governed inference and usage.",
  "ops.modules.support.name": "AI Customer Support",
  "ops.modules.support.description": "Website chat, product characters and human support.",
  "system.files.upload.processing": "Validating and publishing the file. Please wait.",
  "system.files.upload.invalid_content": "The file size or actual type is invalid. Choose another file.",
  "system.files.upload.publish_failed": "Publishing failed. Ask an administrator to check the worker and storage configuration.",
  "system.files.upload.scan_blocked": "The file did not pass the security check and cannot be published.",
  "system.files.public_url": "Public URL",
  "system.files.public_url_not_ready": "The public URL is not ready. Complete cloud storage configuration or wait for publication."
}
